import type { ComponentProps, ReactNode } from 'react'
import clsx from 'clsx'
import styled, { css } from 'styled-components'
import PillInternal from './PillInternal'

export type _BasePillKind = 'primary' | 'secondary' | 'tertiary'
export type _BasePillVariant = 'default' | 'ghost' | 'dark'

const pillStyles = css`
  &:where(.kind-primary):where(.variant-default) {
    --pill-internal-default-color: var(--base-pill-contrast);
    --pill-internal-default-background-color: var(--base-pill-background);
    --pill-internal-default-border-color: var(--base-pill-transparent);
  }

  &:where(.kind-primary):where(.variant-ghost),
  &:where(.kind-primary):where(.variant-dark) {
    --pill-internal-default-color: var(--palette-neutral-surface-normal-contrast);
    --pill-internal-default-background-color: var(--palette-neutral-surface-normal-background);
    --pill-internal-default-border-color: var(--base-pill-transparent);
  }

  &:where(.kind-secondary):where(.variant-default) {
    --pill-internal-default-color: var(--base-pill-foreground);
    --pill-internal-default-background-color: var(--base-pill-transparent);
    --pill-internal-default-border-color: var(--base-pill-foreground);
  }

  &:where(.kind-secondary):where(.variant-dark) {
    --pill-internal-default-color: var(--palette-neutral-surface-static-white);
    --pill-internal-default-background-color: var(--base-pill-transparent);
    --pill-internal-default-border-color: var(--palette-neutral-surface-static-white);
  }

  &:where(.kind-secondary):where(.variant-ghost) {
    --pill-internal-default-color: var(--palette-neutral-surface-normal-foreground);
    --pill-internal-default-background-color: var(--base-pill-transparent);
    --pill-internal-default-border-color: var(--palette-neutral-surface-normal-foreground);
  }

  &:where(.kind-tertiary):where(.variant-default) {
    --pill-internal-default-color: var(--palette-neutral-surface-normal-contrast);
    --pill-internal-default-background-color: var(--base-pill-transparent);
    --pill-internal-default-border-color: var(--base-pill-transparent);
  }

  &:where(.kind-tertiary):where(.variant-dark) {
    --pill-internal-default-color: var(--palette-neutral-surface-static-white);
    --pill-internal-default-background-color: var(--base-pill-transparent);
    --pill-internal-default-border-color: var(--base-pill-transparent);
  }

  &:where(.kind-tertiary):where(.variant-ghost) {
    --pill-internal-default-color: var(--palette-neutral-surface-normal-foreground);
    --pill-internal-default-background-color: var(--base-pill-transparent);
    --pill-internal-default-border-color: var(--base-pill-transparent);
  }
`

const StyledPillInternal = styled(PillInternal)`
  ${pillStyles}
`

interface Props extends ComponentProps<typeof PillInternal>, Utils.PropsWithDataAttributes {
  children?: ReactNode
  className?: string
  kind?: _BasePillKind
  variant?: _BasePillVariant
}

function BasePill({ children, className, kind = 'primary', variant = 'default', ...props }: Props) {
  return <StyledPillInternal
    {...props}
    className={clsx(className, `kind-${kind}`, `variant-${variant}`)}
  >
    {children}
  </StyledPillInternal>
}

export default BasePill
